/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationResult { 
    /**
     * Id Hash. UAI (Unique Application Identifier)
     */
    idHash?: string;
    /**
     * Name
     */
    name?: string;
    /**
     * Commercial Name
     */
    commercialName?: string;
    /**
     * Nif
     */
    nif?: string;
    /**
     * Link
     */
    link?: string;
    /**
     * Type
     */
    type?: string;
    /**
     * Logo. Encoded in Base64 format
     */
    logo?: ApplicationResult.LogoEnum;
}
export namespace ApplicationResult {
    export type LogoEnum = '[B@285f38f6';
    export const LogoEnum = {
        B285f38f6: '[B@285f38f6' as LogoEnum
    };
}


